import apiClient from './apiClient';

const fixTurkishChars = (str) => {
    if (!str) return '';
    
    const turkishChars = {
        'Ä°': 'İ',
        'Ä±': 'ı',
        'ÅŞ': 'Ş',
        'Åş': 'ş',
        'ÄŸ': 'ğ',
        'ÄĞ': 'Ğ',
        'Ã¼': 'ü',
        'Ãœ': 'Ü',
        'Ã¶': 'ö',
        'Ã–': 'Ö',
        'Ã§': 'ç',
        'Ã‡': 'Ç',
        'Diş': 'Diş',
        'Hekimliği': 'Hekimliği'
    };

    return str.replace(
        new RegExp(Object.keys(turkishChars).join('|'), 'g'),
        match => turkishChars[match]
    );
};

export const getCategories = async () => {
    try {
        const response = await apiClient.get('/treatment-categories', {
            params: {
                populate: '*',
                sort: 'id:asc'
            }
        });

        // Veriyi dönüştür
        if (response.data && response.data.data) {
            const transformedData = response.data.data.map(category => ({
                id: category.id,
                name: fixTurkishChars(category.name) || '',
                nameEn: category.nameEn || '',
                slug: category.identifier || `category-${category.id}`,
                identifier: category.identifier || `category-${category.id}`
            }));

            return transformedData;
        }
        
        return [];
    } catch (error) {
        console.error('Kategoriler yüklenirken hata:', error.message);
        return [];
    }
}; 